import { icons, type IconName } from './icons.js'
import type { SvgIconComponent } from './icons.js'

export const getIconByName = (name: IconName) => {
  const Icon = icons[name]
  if (!Icon) {
    throw new Error(`Icon "${name}" not found`)
  }
  return Icon
}

/**
 * Resolve an icon registry key (arbitrary string) to an SvgIconComponent.
 * Returns `undefined` when `key` is absent, empty, or not found in the registry.
 * Safe to call with `undefined` input — no throws.
 */
export const getIconByKey = (key: string | undefined): SvgIconComponent | undefined => {
  if (!key) {return undefined}
  return (icons as Record<string, SvgIconComponent>)[key]
}
